/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
import Tab from '../../component/Inc/Tab';
import PopChangeKey from './_PopChangeKey';
function ManageChangeKey() {
  const [modalOpen, setModalOpen] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '요청', value: 0},
    {title: '승인', value: 1},
    {title: '승인불가', value: 2}
  ];

  return (
    <main className="com_container p_change_key">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_12">홍보키 변경</h2>
          <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">
            홍보키 변경 요청
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="110" />
                <col width="110" />
                <col width="110" />
                <col width="110" />
                <col width="110" />
                <col width="110" />
                <col width="auto" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>신청일</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>기존 홍보키</th>
                  <th>변경 홍보키</th>
                  <th>담임</th>
                  <th>신청자</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(10)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>
                      <button className="btn_link">2023, 05, 12</button>
                    </td>
                    <td>
                      <button className="btn_link">김학생123</button>
                    </td>
                    <td>수학</td>
                    <td>
                      담홍
                      <br />
                      홍길동123
                    </td>
                    <td>
                      소개 <br />
                      최길리456
                    </td>
                    <td>홍길동123</td>
                    <td>홍길동123</td>
                    <td className="td_point">
                      승인 <br />
                      김승인123 <br />
                      2024, 05, 12
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit"></button>
                <button className="btn_delete"></button>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="com_blue_txt">홍학생103 (고3ㆍ본사 ) </span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <span className="cont">010-1234-134</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">김담임445</span>
                </div>
                <div className="info">
                  <span className="tit">기존회원 여부</span>
                  <span className="cont">-</span>
                </div>
                <div className="info">
                  <span className="tit">온라인</span>
                  <span className="cont">-</span>
                </div>
                <div className="info">
                  <span className="tit">CPA</span>
                  <span className="cont">-</span>
                </div>
                <div className="info">
                  <span className="tit">비회원 문의 전화</span>
                  <span className="cont">-</span>
                </div>
                <div className="info">
                  <span className="tit">홍보책자</span>
                  <span className="cont">-</span>
                </div>
              </div>
            </div>
            <div className="com_input_wrap">
              <table className="com_board_list">
                <colgroup>
                  <col width="auto" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                </colgroup>
                <thead>
                  <tr>
                    <th>등록일</th>
                    <th>과목</th>
                    <th>기존 홍보키</th>
                    <th>영업형태</th>
                    <th>상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2023, 05, 12</td>
                    <td>수학</td>
                    <td>최홍보123</td>
                    <td>소개</td>
                    <td>진행중</td>
                  </tr>
                  <tr>
                    <td>2023, 05, 12</td>
                    <td>수학</td>
                    <td>최홍보123</td>
                    <td>소개</td>
                    <td>취소 </td>
                  </tr>
                  <tr>
                    <td>2023, 05, 12</td>
                    <td>수학</td>
                    <td>최홍보123</td>
                    <td>소개</td>
                    <td>중단 </td>
                  </tr>
                  <tr>
                    <td>2023, 05, 12</td>
                    <td>수학</td>
                    <td>최홍보123</td>
                    <td>소개</td>
                    <td>종료</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="com_info center">
              <p className="name">변경할 홍보키 : 김홍보123</p>
            </div>

            <div className="com_input_wrap">
              <textarea name="" id="" placeholder="사유 등록 및 증빙서류"></textarea>
            </div>
            <div className="upload_wrap">
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
              </div>
              <ul className="file_list">
                <li>
                  <div className="com_input_upload">
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="com_input_upload">
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <hr className="com_divider" />
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon blue">반려</span>
                    <button className="name">김관리103 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">증빈서류가 부족합니다.</div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_row">
                <select className="select">
                  <option value="승인">승인</option>
                </select>
              </div>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="내용 입력"></textarea>
              </div>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs wl">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopChangeKey open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
}

export default ManageChangeKey;
